/*
  TSi Shop : liste déroulante des imprimantes (combobox ARIA).

  Amélioration progressive d'un champ <input data-tsi-combobox list="ID"> : la <datalist>
  rendue par snippets/tsi-liste-imprimantes.liquid reste la source des noms et le repli
  sans JavaScript. Le script retire l'attribut list et affiche sa propre liste :
  - correspondance insensible à la casse, aux accents, espaces, tirets, points et barres
    (même normalisation que tsi-finder.js) : « tm l100 » trouve « Epson TM-L100 » ;
  - variantes d'écriture dédoublonnées (« MC-Label3 » et « mC-Label3 » : une seule entrée) ;
  - noms groupés par marque (premier mot), partie saisie en gras ;
  - clavier : flèches, Entrée pour choisir, Échap pour fermer ; souris et tactile ;
  - le choix remplit le champ et déclenche un événement « input » : le finder filtre aussitôt.

  Attributs du champ :
  - data-tsi-combobox="en-ligne" : liste dans le flux (panneau qui défile, ex. filtres du
    finder) au lieu d'un panneau flottant ;
  - data-tsi-combobox-label : nom accessible de la liste ;
  - data-tsi-combobox-vide : texte affiché quand aucune imprimante ne correspond ;
  - data-tsi-combobox-whatsapp / -whatsapp-libelle : lien de contact de l'état vide.
*/
(function () {
  function normaliser(texte) {
    return String(texte || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\s\-_.\/]/g, '');
  }

  var compteur = 0;

  function initialiser(champ) {
    var source = document.getElementById(champ.getAttribute('list') || '');
    if (!source || champ.hasAttribute('data-tsi-combobox-pret')) return;
    champ.setAttribute('data-tsi-combobox-pret', '');

    // Noms uniques après normalisation, dans l'ordre de la datalist (déjà triée)
    var vus = {};
    var noms = [];
    source.querySelectorAll('option').forEach(function (o) {
      var nom = (o.value || '').trim();
      var cle = normaliser(nom);
      if (!nom || vus[cle]) return;
      vus[cle] = true;
      noms.push({ nom: nom, cle: cle, mots: nom.split(/\s+/).map(normaliser), marque: nom.split(/\s+/)[0], rang: noms.length });
    });
    if (!noms.length) return;

    compteur += 1;
    var idListe = (champ.id || 'TsiCombobox') + '-liste-' + compteur;
    // Mode « en ligne » : la liste suit la ligne du champ (qui peut contenir d'autres
    // boutons) dans le flux. Sinon elle flotte sous le champ, dans son conteneur.
    var enLigne = champ.getAttribute('data-tsi-combobox') === 'en-ligne';
    var ligne = champ.parentNode;
    var conteneur = enLigne ? ligne.parentNode : ligne;
    conteneur.classList.add('tsi-combobox');
    if (enLigne) conteneur.classList.add('tsi-combobox--en-ligne');

    var panneau = document.createElement('div');
    panneau.className = 'tsi-combobox__panneau';
    panneau.id = idListe;
    panneau.setAttribute('role', 'listbox');
    panneau.setAttribute('aria-label', champ.getAttribute('data-tsi-combobox-label') || '');
    panneau.hidden = true;
    if (enLigne) ligne.insertAdjacentElement('afterend', panneau);
    else conteneur.appendChild(panneau);

    champ.removeAttribute('list');
    champ.setAttribute('role', 'combobox');
    champ.setAttribute('aria-autocomplete', 'list');
    champ.setAttribute('aria-expanded', 'false');
    champ.setAttribute('aria-controls', idListe);

    var options = [];
    var actif = -1;
    var enSelection = false;

    // Nom avec la partie saisie en gras (correspondance simple, sans normalisation)
    function remplirNom(el, nom, saisie) {
      var i = saisie ? nom.toLowerCase().indexOf(saisie.toLowerCase()) : -1;
      if (i === -1) { el.textContent = nom; return; }
      el.appendChild(document.createTextNode(nom.slice(0, i)));
      var b = document.createElement('b');
      b.textContent = nom.slice(i, i + saisie.length);
      el.appendChild(b);
      el.appendChild(document.createTextNode(nom.slice(i + saisie.length)));
    }

    function rendre() {
      var saisie = champ.value.trim();
      var q = normaliser(saisie);
      var trouves = noms.filter(function (n) { return !q || n.cle.indexOf(q) !== -1; });
      // Classement : nom qui commence par la saisie (0), un mot qui commence par la
      // saisie (1), simple présence (2). Les marques restent groupées, la meilleure en tête.
      if (q) {
        var meilleur = {};
        trouves.forEach(function (n) {
          n.score = n.cle.indexOf(q) === 0 ? 0 : n.mots.some(function (m) { return m.indexOf(q) === 0; }) ? 1 : 2;
          if (!(n.marque in meilleur) || n.score < meilleur[n.marque]) meilleur[n.marque] = n.score;
        });
        trouves.sort(function (a, b) {
          return (meilleur[a.marque] - meilleur[b.marque]) || (a.marque < b.marque ? -1 : a.marque > b.marque ? 1 : 0) || (a.score - b.score) || (a.rang - b.rang);
        });
      }
      panneau.textContent = '';
      options = [];
      actif = -1;
      champ.removeAttribute('aria-activedescendant');

      if (!trouves.length) {
        var vide = document.createElement('div');
        vide.className = 'tsi-combobox__vide';
        vide.setAttribute('role', 'presentation');
        var texte = document.createElement('span');
        texte.textContent = champ.getAttribute('data-tsi-combobox-vide') || '';
        vide.appendChild(texte);
        var wa = champ.getAttribute('data-tsi-combobox-whatsapp');
        if (wa) {
          var lien = document.createElement('a');
          lien.href = wa;
          lien.target = '_blank';
          lien.rel = 'noopener';
          lien.textContent = champ.getAttribute('data-tsi-combobox-whatsapp-libelle') || 'WhatsApp';
          vide.appendChild(lien);
        }
        panneau.appendChild(vide);
        return;
      }

      var groupe = null;
      var marqueCourante = null;
      trouves.forEach(function (n) {
        if (n.marque !== marqueCourante) {
          marqueCourante = n.marque;
          groupe = document.createElement('div');
          groupe.setAttribute('role', 'group');
          groupe.setAttribute('aria-label', n.marque);
          var titre = document.createElement('div');
          titre.className = 'tsi-combobox__marque';
          titre.setAttribute('aria-hidden', 'true');
          titre.textContent = n.marque;
          groupe.appendChild(titre);
          panneau.appendChild(groupe);
        }
        var opt = document.createElement('div');
        opt.className = 'tsi-combobox__option';
        opt.id = idListe + '-' + options.length;
        opt.setAttribute('role', 'option');
        opt.setAttribute('aria-selected', 'false');
        opt.setAttribute('data-valeur', n.nom);
        remplirNom(opt, n.nom, saisie);
        groupe.appendChild(opt);
        options.push(opt);
      });
    }

    function ouvrir() {
      rendre();
      panneau.hidden = false;
      champ.setAttribute('aria-expanded', 'true');
    }

    function fermer() {
      panneau.hidden = true;
      champ.setAttribute('aria-expanded', 'false');
      champ.removeAttribute('aria-activedescendant');
      actif = -1;
    }

    function activer(index) {
      if (actif !== -1 && options[actif]) {
        options[actif].classList.remove('is-actif');
        options[actif].setAttribute('aria-selected', 'false');
      }
      actif = index;
      if (actif === -1 || !options[actif]) { champ.removeAttribute('aria-activedescendant'); return; }
      options[actif].classList.add('is-actif');
      options[actif].setAttribute('aria-selected', 'true');
      champ.setAttribute('aria-activedescendant', options[actif].id);
      options[actif].scrollIntoView({ block: 'nearest' });
    }

    function choisir(opt) {
      champ.value = opt.getAttribute('data-valeur');
      fermer();
      enSelection = true;
      champ.dispatchEvent(new Event('input', { bubbles: true }));
      champ.dispatchEvent(new Event('change', { bubbles: true }));
      enSelection = false;
    }

    champ.addEventListener('focus', ouvrir);
    champ.addEventListener('click', function () { if (panneau.hidden) ouvrir(); });
    champ.addEventListener('input', function () { if (!enSelection) ouvrir(); });

    champ.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (panneau.hidden) ouvrir();
        activer(Math.min(actif + 1, options.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (!panneau.hidden) activer(Math.max(actif - 1, 0));
      } else if (e.key === 'Enter') {
        // Sans option active, Entrée garde son comportement (envoi du formulaire)
        if (!panneau.hidden && actif !== -1) {
          e.preventDefault();
          choisir(options[actif]);
        }
      } else if (e.key === 'Escape') {
        if (!panneau.hidden) {
          e.preventDefault();
          fermer();
        }
      } else if (e.key === 'Tab') {
        fermer();
      }
    });

    // mousedown : choisir avant que le champ ne perde le focus
    panneau.addEventListener('mousedown', function (e) {
      if (e.target.closest('a')) return;
      e.preventDefault();
      var opt = e.target.closest('[role="option"]');
      if (opt) choisir(opt);
    });

    document.addEventListener('pointerdown', function (e) {
      if (!panneau.hidden && !conteneur.contains(e.target)) fermer();
    });
    champ.addEventListener('blur', function () {
      // Laisse passer un clic sur le lien WhatsApp de l'état vide
      setTimeout(function () { if (!conteneur.contains(document.activeElement)) fermer(); }, 150);
    });
  }

  function tout() {
    document.querySelectorAll('input[data-tsi-combobox][list]').forEach(initialiser);
  }
  tout();
  // Éditeur de thème : sections rechargées
  document.addEventListener('shopify:section:load', tout);
})();
